export class User {
	constructor() {
	}
} 
